import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/vueScrollmagic'
import App from './App.vue'
import router from './router'
import VModal from 'vue-js-modal'
import VueGTag from 'vue-gtag'

Vue.use(VModal, { dialog: true })
Vue.config.productionTip = false
document.api_host = '/data'
document.isPopped = false
const options = {
  config: {
    id: 'UA-145368203-1' // replace GA_MEASUREMENT_ID with your ID
  }
}
Vue.use(VueGTag, options, router)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
